<template>
  <div>
    <collapse :multiple-active="false" :active-index="-1">
      <collapse-form-item
        id="PreOrderDetailStep"
        @tabOpen="loadItem"
        :status="preOrderStatus"
        v-bind:tabChange="getSubmissionState.submission"
        name="1"
        title="Pre Order Details"
      >
     <span>
</span>
        <div>
          <pre-order-detail
            :is-read-only="isReadOnly"
            ref="PreOrderDetailStep"
            @validated="onSubStepValidated"
          ></pre-order-detail>
        </div>
      </collapse-form-item>
      <collapse-form-item
        id="AgreementInformationStep"
        :disabled="$route.params.id <= 0"
        title="Agreement Information"
        @tabOpen="loadItem"
        :status="agreementInformationStatus"
        v-bind:tabChange="getSubmissionState.submission"
        name="2"
      >
        <div>
          <agreement-information
            :is-read-only="isReadOnly"
            ref="AgreementInformationStep"
            @validated="onSubStepValidated"
          ></agreement-information>
        </div>
      </collapse-form-item>
      <collapse-form-item
        id="DeliverytInformationStep"
        title="Delivery Information"
        @tabOpen="loadItem"
        :status="deliveryInformationStatus"
        v-bind:tabChange="getSubmissionState.submission"
        name="3"
      >
        <div>
          <delivery-information
            :is-read-only="isReadOnly"
            ref="DeliverytInformationStep"
            @validated="onSubStepValidated"
          ></delivery-information>
        </div>
      </collapse-form-item>
      <collapse-form-item
        id="TransactionInformationStep"
        title="Transaction Information"
        @tabOpen="loadItem"
        :status="transactionInformationStatus"
        v-bind:tabChange="getSubmissionState.submission"
        name="4"
      >
        <div>
          <transaction-information
            :is-read-only="isReadOnly"
            ref="TransactionInformationStep"
            @validated="onSubStepValidated"
          ></transaction-information>
        </div>
      </collapse-form-item>

      <collapse-form-item
        id="LineItemStep"
        title="Line Item(s)"
        @tabOpen="loadItem"
        :status="lineItemStatus"
        name="5"
      >
        <div>
          <line-item
            :is-read-only="isReadOnly"
            ref="LineItemStep"
            @validated="onSubStepValidated"
          ></line-item>
        </div>
      </collapse-form-item>
      <collapse-form-item
        id="ReplacementItemStep"
        title="Replacement Line Item(s)"
        @tabOpen="loadItem"
        :status="replacementItemStatus"
        v-bind:tabChange="getSubmissionState.submission"
        name="6"
      >
        <div>
          <replacement-item
            :is-read-only="isReadOnly"
            ref="ReplacementItemStep"
            @validated="onSubStepValidated"
          ></replacement-item>
        </div>
      </collapse-form-item>
      <collapse-form-item
        id="FinanceOfficeStep"
        title="Finance Offices"
        @tabOpen="loadItem"
        :status="financeOfficeStatus"
        v-bind:tabChange="getSubmissionState.submission"
        name="7"
      >
        <div>
          <finance-office
            :is-read-only="isReadOnly"
            ref="FinanceOfficeStep"
            @validated="onSubStepValidated"
          ></finance-office>
        </div>
      </collapse-form-item>
      <collapse-form-item
        id="AuthorizedRequestorStep"
        title="Authorized Requestor"
        @tabOpen="loadItem"
        :status="authorizedRequestorSubmitStatus"
        v-bind:tabChange="getSubmissionState.submission"
        name="8"
      >
        <div>
          <authorized-requestor-submit
            :is-read-only="isReadOnly"
            ref="AuthorizedRequestorStep"
            @validated="onSubStepValidated"
          >
          </authorized-requestor-submit>
        </div>
      </collapse-form-item>
      <collapse-form-item
        id="AuthorizedAcceptorStep"
        title="Authorized Acceptor"
        @tabOpen="loadItem"
        :status="authorizedAcceptorSubmitStatus"
        name="9"
      >
        <div>
          <authorized-acceptor-submit
            :is-read-only="isReadOnly"
            ref="AuthorizedAcceptorStep"
            @validated="onSubStepValidated"
          >
          </authorized-acceptor-submit>
        </div>
      </collapse-form-item>
    </collapse>

    <!-- <br />
            <div class="align-center">
                <button class="btn btn-danger">
                    <i class="tim-icons icon-trash-simple"></i> Delete Order
                </button>
            </div> -->
  </div>
</template>

<script>
import PreOrderDetail from "@/components/App/order/submission/PreOrderDetail.vue";
import AgreementInformation from "@/components/App/order/submission/agreement/AgreementInformation.vue";
import DeliveryInformation from "@/components/App/order/submission/DeliveryInformation.vue";
import TransactionInformation from "@/components/App/order/submission/TransactionInformation.vue";
import FinanceOffice from "@/components/App/order/submission/FinanceOffice.vue";
import LineItem from "@/components/App/order/submission/lineitem/LineItem.vue";
import ReplacementItem from "@/components/App/order/submission/replacementitem/ReplacementItem.vue";
import AuthorizedRequestorSubmit from "@/components/App/order/submission/signature/AuthorizedRequestorSubmit.vue";
import AuthorizedAcceptorSubmit from "@/components/App/order/submission/signature/AuthorizedAcceptorSubmit.vue";
import { Select, Option } from "element-ui";
import { BaseRadio, Collapse, CollapseFormItem } from "@/components/index";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "Submission",
  props: ["isReadOnly"],
  components: {
    PreOrderDetail,
    AgreementInformation,
    DeliveryInformation,
    TransactionInformation,
    FinanceOffice,
    LineItem,
    ReplacementItem,
    AuthorizedRequestorSubmit,
    AuthorizedAcceptorSubmit,
    Collapse,
    CollapseFormItem,
    [Select.name]: Select,
    [Option.name]: Option,
    BaseRadio,
  },

  data() {
    return {
      firstLoad: true,
      status: null,
     

    };
  },

  async mounted() {
    this.getPreOrderStatus(this.$route.params.id);
    this.getAgreementInformationStatus(this.$route.params.id);
    this.getDeliveryInformationStatus(this.$route.params.id);
    this.getTransactionInformationStatus(this.$route.params.id);
    this.getLineItemStatus(this.$route.params.id);
    this.getReplacementItemStatus(this.$route.params.id);
    this.getFinanceOfficeStatus(this.$route.params.id);
    this.getAuthorizedRequestorSubmitStatus(this.$route.params.id);
    this.getAuthorizedAcceptorSubmitStatus(this.$route.params.id);
   
  },
  computed: {
    ...mapGetters({
      preOrderStatus: "preOrderDetail/preOrderStatus",
      agreementInformationStatus:
        "agreementInformation/agreementInformationStatus",
      deliveryInformationStatus:
        "deliveryInformation/deliveryInformationStatus",
      transactionInformationStatus:
        "transactionInformation/transactionInformationStatus",
      financeOfficeStatus: "financeOffice/financeOfficeInformationStatus",
      lineItemStatus: "lineItem/lineItemStatus",
      replacementItemStatus: "replacementItem/replacementItemStatus",
      authorizedRequestorSubmitStatus:"authorizedRequestor/authorizedRequestorSubmitStatus",
      authorizedAcceptorSubmitStatus:"authorizedAcceptor/authorizedAcceptorSubmitStatus",
      requisitionNumber: "orderMetadata/requisitionNumber",
      orderStatus: "orderMetadata/orderStatus",
      getSubmissionState: "moduleState/getAllStates",
      

    }),
    isSubmissionCompleted() {
      return (
        this.preOrderStatus &&
        this.agreementInformationStatus &&
        this.deliveryInformationStatus &&
        this.transactionInformationStatus &&
        this.lineItemStatus &&
        this.replacementItemStatus &&
        this.financeOfficeStatus &&
        this.authorizedRequestorSubmitStatus &&
        this.authorizedAcceptorSubmitStatus
      );
    },
  },
  methods: {
    ...mapActions({
      getPreOrderStatus: "preOrderDetail/getPreOrderStatus",
      getAgreementInformationStatus: "agreementInformation/getAgreementInformationStatus",
      getDeliveryInformationStatus: "deliveryInformation/getDeliveryInformationStatus",
      getTransactionInformationStatus: "transactionInformation/getTransactionInformationStatus",
      getLineItemStatus: "lineItem/getLineItemStatus",
      getReplacementItemStatus: "replacementItem/getReplacementItemStatus",
      getFinanceOfficeStatus: "financeOffice/getFinanceOfficeInformationStatus",
      getAuthorizedRequestorSubmitStatus:"authorizedRequestor/getAuthorizedRequestorSubmitStatus",
      getAuthorizedAcceptorSubmitStatus:"authorizedAcceptor/getAuthorizedAcceptorSubmitStatus",
      submitSubmission: "orderMetadata/submitSubmission",
    }),
  
    onSubStepValidated(validated, model) {
      this.$emit("on-validated", validated, model);
    },
    loadItem(ref, active) {
      if(active) {
        return this.$refs[ref].loaded();
      }
    },
    validate() {
      return this.$validator.validateAll().then((res) => {
        this.$emit("on-validated", res, this.model);
        return res;
      });
    },
   
  },
};
</script>

<style scoped>
@import "../../../styles/custom_grid.css";

.card-collapse .card.card-plain.has-danger .card-header:after {
  background: #ec250d;
}

.card-collapse .card.card-plain.has-success .card-header:after {
  background: #10b45a;
}
</style>
